/**
 * Local-dev fallback for console config, isolated here so runtimeConfig.ts holds no
 * `import.meta` reference a test environment has to shim. Copied from the product
 * SPA's viteDevEnv pattern.
 */
import type { ConsoleConfig } from "./runtimeConfig";

export function isViteDev(): boolean {
  try {
    return Boolean(import.meta.env?.DEV);
  } catch {
    return false;
  }
}

export function viteFallbackConfig(): ConsoleConfig {
  const env = (import.meta.env ?? {}) as Record<string, string | undefined>;
  return {
    functionAppUrl: (env.VITE_CONSOLE_FUNCTION_APP_URL || "").trim(),
    entraTenantId: (env.VITE_CONSOLE_ENTRA_TENANT_ID || "").trim(),
    entraClientId: (env.VITE_CONSOLE_ENTRA_CLIENT_ID || "").trim(),
    entraAuthority: (env.VITE_CONSOLE_ENTRA_AUTHORITY || "").trim(),
  };
}
